import React from 'react';

function SendMifsFullProcess() {
  return <div>SendMifsFullProcess</div>;
}

export default SendMifsFullProcess;
